import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import * as S from './styled'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ActionDialog from '../action-dialog'
import i18n from '../../../assets/i18n'

function SimpleDialog(props) {
  const { onClose, open, defaultMessages } = props

  // Cerrar sin argumentos: onClose(value) es elegir un mensaje
  function handleClose() {
    onClose()
  }

  function handleListItemClick(value) {
    onClose(value)
  }

  return (
    <ActionDialog
      open={open}
      title={i18n.simpleDialog.defaultMessages}
      onClose={handleClose}
      onConfirm={handleClose}
      confirmLabel={i18n.simpleDialog.close}
      showCancel={false}
    >
      <List disablePadding>
        {defaultMessages && defaultMessages.length > 0
          ? defaultMessages.map(message => (
              <ListItem style={S.itemStyle} button onClick={() => handleListItemClick(message)} key={message.id}>
                <S.Title>{message.title}</S.Title>
              </ListItem>
            ))
          : ''}
      </List>
    </ActionDialog>
  )
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  defaultMessages: PropTypes.array.isRequired,
  open: PropTypes.bool.isRequired
}

const enharce = compose()

export default enharce(SimpleDialog)
